import React from 'react';

import { I18n } from '@interlayer/js/components/common/I18n';

import { fromPath } from '@interlayer/js/app/utils/common.util';

const hasUserErrors = (error) => {
    const userErrors = fromPath(error, 'data.userErrors');

    return Boolean(userErrors?.length);
};

const hasActions = (error) => {
    const actionsError = fromPath(error, 'data.actions');

    return Boolean(actionsError && Object.keys(actionsError).length);
};

const createMessage = (key, defaultValue) => (
    <I18n
        tKey={`playtech.mobile.system.registration.error.${key}`}
        defaultValue={defaultValue}
    />
);

const createMessageByDefault = (error) => {
    const data = error && error.data || {};
    const defaultMessage = data.playerMessage || data.errorMessage || data.errorText || data.message;

    return createMessage(data.errorCode, defaultMessage);
};

const createMessageByUserErrors = (error) => {
    const userErrors = fromPath(error, 'data.userErrors');

    return createMessage(userErrors[0].templateId, userErrors[0].message);
};

const createMessageFromActionsArray = (data, defaultMessage) => {
    const { actions } = data;
    const messages = actions
        .filter((action) => action.showMessageNotificationInfo && action.showMessageNotificationInfo.message)
        .map((action) => action.showMessageNotificationInfo.message);

    return messages.length
        ? messages
        : createMessage(data.errorCode, defaultMessage);
};

const createMessageFromActionsObject = (data, defaultMessage) => {
    const actionMessages = data.actions.PlayerActionShowMessage || [];
    const message = actionMessages[0]
        ? actionMessages[0].message
        : defaultMessage;

    return createMessage(data.errorCode, message);
};

const createMessageByActions = (error) => {
    const { data } = error;
    const defaultMessage = data.playerMessage || data.errorMessage || data.errorText;

    if (Array.isArray(data.actions)) {
        return createMessageFromActionsArray(data, defaultMessage);
    }

    return createMessageFromActionsObject(data, defaultMessage);
};

export const getRegistrationErrorMessage = (error) => {
    if (hasUserErrors(error)) {
        return createMessageByUserErrors(error);
    }

    if (hasActions(error)) {
        return createMessageByActions(error);
    }

    return createMessageByDefault(error);
};
